import cx from 'classnames';
import Button from 'components/Button/BaseButton';
import { Small } from 'components/text';
import RightArrowIcon from 'blocks/CareerListSection/icons/RightArrow';
import CloseIcon from 'blocks/CareerListSection/icons/CloseIcon';

import styles from './ExpandButton.module.scss';

type ExpandButtonProps = {
  expanded?: boolean;
  withLabel?: boolean;
};

const ExpandButton = ({
  expanded = false,
  withLabel = true,
}: ExpandButtonProps) => {
  if (expanded) {
    return (
      <Button className={styles.closeButton}>
        <CloseIcon />
      </Button>
    );
  }
  return (
    <Button
      className={cx(styles.expandButton, { [styles.circleIcon]: !withLabel })}
    >
      {withLabel && <Small>View details</Small>}
      <RightArrowIcon />
    </Button>
  );
};

export default ExpandButton;
